import type { TOC } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import type { EmberChangeset } from 'ember-changeset';
import t from 'ember-intl/helpers/t';
import Dropdown from 'ui-kit/components/changeset/dropdown';

interface Signature {
  Args: {
    changeset: EmberChangeset;
  };
}

const LifestyleDropdownComponent: TOC<Signature> = <template>
  <Dropdown
    @labelName='Mode de vie'
    @propertyName='housing'
    @allowAdditions={{true}}
    @changeset={{@changeset}}
    as |dropdown|
  >
    {{#each
      (array
        'single'
        'parentsPlace'
        'ownFamilyHome'
        'childrenHome'
        'anotherFamilyMember'
        'houseShare'
        'community'
      )
      as |key|
    }}
      <dropdown.Item
        @value={{t (concat 'lifestyle.housing.' key)}}
        @key={{key}}
      />
    {{/each}}
  </Dropdown>
</template>;

export default LifestyleDropdownComponent;
